import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config';

/**
 * Firebase Auth のセッション復元を待つ。
 *
 * ページ読み込み直後は復元が完了しておらず `currentUser` が null になる。
 * それを待たずにトークンを取ろうとすると、ログイン済みでも未ログイン扱いに
 * なってしまう（リロードでログアウトされる）。
 */
async function waitForCurrentUser() {
  if (auth.currentUser) {
    return auth.currentUser;
  }

  await new Promise<void>((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      unsubscribe();
      resolve();
    });
  });

  return auth.currentUser;
}

/**
 * Cloud Functions 呼び出し用の認証ヘッダーを作る。
 *
 * 以前は `X-User-ID` に uid を入れて送っていたが、ヘッダーは呼び出す側が
 * 自由に決められるため、他人の uid を指定すればなりすませる状態だった。
 * 偽装できないIDトークンを送る形に統一する。
 *
 * 設計書: レフリアメモ/認証の一本化について.md
 */
export async function buildAuthHeaders(): Promise<Record<string, string>> {
  const user = await waitForCurrentUser();
  const idToken = await user?.getIdToken();

  if (!idToken) {
    throw new Error('ログインが必要です');
  }

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
  };
}
